
import { Vue, Component, Emit, Prop, Watch } from "vue-property-decorator";
import { isMobile, isTablet } from "mobile-device-detect";
import { apiSaveLead, apiPrintPDF } from "./../../api";
import { ModalType,Settings,TimeSlots } from "./../../constant";
import { LeadData, PrintRequest } from "./../../types";
import Calendar from "./../Calendar.vue";
import html2canvas from "html2canvas";
import { apiMessages } from "../../api/message-api";

@Component({
  components: {
    Calendar,
  },
})
export default class ContactInformation extends Vue {
  $refs: any;
  private firstName = "";
  private lastName = "";
  private email = "";
  private confirmEmail = "";
  private questions = "";
  private messages: any = {};
  private isRequiredMessages: any = {};
  private marketingOptIn = false;
  private isRealtor = false;
  private isVirtualTour = false;
  private selectedTimeSlot = "";
  private errors: Array<string> = [];
  private loading = false;
  private timeSlots = TimeSlots;

  @Prop() private printOptionSelected!: boolean;
  @Prop() private neighborhoodAreaName!: string;
  @Prop() private areaId!: string;
  @Prop() private neighborhoodName!: string;
  @Prop() private neighborhoodId!: string;
  @Prop() private topPosition!: number;
  @Prop() private legends!: string;

  @Emit("closeModal") closeModal(modalName: string) {}
  @Emit("openModal") openModal(modalName: string) {}
  @Emit("openPrintModal") openPrintModal() {}

  constructor() {
    super();
    this.loadMessages();
  }

  async loadMessages() {
    const { messages, validationMessage } = await apiMessages(
      "ContactInformation"
    );
    this.messages = messages;
    this.isRequiredMessages = validationMessage;
  }

  submitData(e) {
    e.preventDefault();
    this.loading = true;
    this.errors = [];
    let timer = setTimeout((_) => {
      this.submitContactInfo(e);
      clearTimeout(timer);
    }, 1);
  }

  async submitContactInfo(e) {
    this.loading = true;
    this.ValidateName();
    this.ValidateEmail();
    !this.printOptionSelected && this.validateDateTime();
    if (!this.errors.length) {
      this.submitForm();
    } else this.loading = false;
  }

  ValidateName() {
    this.isEmptyField(this.firstName, this.isRequiredMessages.firstName);
    this.isNameValid(this.firstName, this.isRequiredMessages.validFirstName, 0);
    this.isEmptyField(this.lastName, this.isRequiredMessages.lastName);
    this.isNameValid(this.lastName, this.isRequiredMessages.validLastName, 2);
  }

  ValidateEmail() {
    this.isEmptyField(this.email, this.isRequiredMessages.email);
    this.isEmptyField(this.confirmEmail, this.isRequiredMessages.confirmEmail);
    if (this.email && !this.validEmail(this.email)) {
      this.errors.push(this.isRequiredMessages.validEmail);
    }
    if (this.email && this.email !== this.confirmEmail) {
      this.errors.push(this.isRequiredMessages.emailMismatch);
    }
  }

  validateDateTime() {
    if (!this.$refs.calender.date) {
      this.errors.push(this.isRequiredMessages.requiredDate);
    }
    if(!this.selectedTimeSlot) {
      this.errors.push(this.isRequiredMessages.requiredTime);
    }
  }

  isNameValid(field, fieldText, minimumLength) {
    if (
      field &&
      this.isOnlyCharacter(field, fieldText) &&
      field.length < minimumLength
    ) {
      this.errors.push(this.isRequiredMessages.validLastName2);
    }
  }

  isOnlyCharacter(field, fieldText) {
    let isValid = true;
    if (field && !/^[a-zA-Z]+$/.test(field)) {
      isValid = false;
      this.errors.push(fieldText);
    }
    return isValid;
  }

  isEmptyField(field, fieldText) {
    if (!field) {
      this.errors.push(fieldText);
    }
  }

  async submitForm() {
    try {
      const dates = !this.printOptionSelected ? this.$refs.calender.date : "";
      const leadObject: LeadData = {
        areaId: this.fixAreaName(this.neighborhoodAreaName),
        firstName: this.firstName,
        lastName: this.lastName,
        emailAddress: this.email,
        commentsQuestions: this.getCommentQuestion(dates),
        marketingOptIn: this.marketingOptIn,
        isRealtor: this.isRealtor,
        preferredVisitDates: dates,
        source: "Sales Plat",
        timestamp: new Date(),
        leadType: "RI: Find a New Home",
        urlRef: window.location.href,
      };
      const response = await apiSaveLead(leadObject);
      window.sessionStorage.setItem(Settings.SESSION_KEY, "Submitted");
      this.handleResponse(response);
    } catch (error) {
      this.loading = false;
      this.errors = [];
      this.errors.push(this.messages.errorMessage);
    }
  }

  fixAreaName(areaName) {
    let newAreaName = areaName
    if(newAreaName.toLowerCase().includes('wash')){
      newAreaName = 'Drees Washington DC'
    }
    return newAreaName
  }

  getCommentQuestion(dates) {
    return this.printOptionSelected
      ? this.questions
      : this.getCommentQuestionByDates(dates);
  }

  getCommentQuestionByDates(dates) {
    let commentString = `Want to visit ${dates} ${this.selectedTimeSlot}`;
    if (this.questions) {
      commentString += ` | ${this.questions}`;
    }
    if (this.isVirtualTour) {
      commentString += ` | Virtual Tour requested`;
    }
    return commentString;
  }

  clearData() {
    this.firstName = "";
    this.lastName = "";
    this.email = "";
    this.confirmEmail = "";
    this.questions = "";
    this.marketingOptIn = false;
    this.isRealtor = false;
    this.isVirtualTour = false;
    this.selectedTimeSlot = "";
    this.errors = [];
  }
  validEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  handleResponse(response) {
    this.clearData();
    this.loading = false;
    this.closeModal(ModalType.CONTACT_INFO);
    if (response && this.printOptionSelected) {
      this.openPrintModal();
    }
  }

  handleClose() {
    this.clearData();
    this.closeModal(ModalType.CONTACT_INFO);
  }
}
